<template>
    <v-container fluid>
        <v-row align="start" justify="center">
            <v-col cols="12" md="10" sm="10">
                <v-card class="elevation-4">
                    <v-card-title>
                        Diet List
                        <div class="flex-grow-1"></div>
                        <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                        ></v-text-field>
                        <v-btn color="primary" class="ml-3" @click="$router.push('/business/creatediet')">Create Diet</v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-divider></v-divider>
                        <v-data-table
                            :headers="headers"
                            :items="diets"
                            :items-per-page="20"
                            :search="search"
                            class="elevation-1">

                           
                            <template v-slot:item.action="{ item }">
                                                            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                                <v-icon small @click="deleteItem(item)">delete</v-icon>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    
</template>
<script >
import Vue from 'vue'
export default {
    data: () => ({
        search: "",
        headers: [
        { text: "Diest Name", value: "name" },
        { text: "Created At", value: "created_at" },
        { text: "Actions", value: "action", sortable: false }
        ],
        diets: []
    }),
    created() {
      let business = JSON.parse(localStorage.getItem("business") || "{}");
      this.$http
      .get(this.$apidomain+"business/dietList")
      .then(res => {
       this.diets = res.data.diets;
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    methods: {
    editItem(item){
        this.$router.push({name:'editddiet',params:{id:item.id}});
    },
    deleteItem(item) {
        
      if (confirm("Are you sure you want to delete this Diet?")) {
          this.$http
      .post(this.$apidomain+"business/deleteDiet/"+item.id)
      .then(res => {
        //this.businesses = res.data.businesses;
         this.$router.push("/business/dietlist");
      })
      .catch(err => {
        console.log(err.response);
      });
      }
    },
    createagent(){
        this.$router.push('/createemployee');
    }
  }

}
</script>